'use client';

import React from 'react';

interface EMTSyncLogoProps {
  variant?: 'light' | 'dark';
  height?: number;
  iconOnly?: boolean;
  className?: string;
}

export default function EMTSyncLogo({
  variant = 'dark',
  height = 62, // Increased from 48 to 62 (30% larger)
  iconOnly = false,
  className = '',
}: EMTSyncLogoProps) {
  // Color scheme based on variant
  const arrowColor = '#2563EB'; // Blue arrows for both variants
  const emtTextColor = variant === 'light' ? '#FFFFFF' : '#0B1F3A';
  const syncTextColor = '#2563EB'; // Sync always blue

  // Calculate proportional dimensions (30% larger)
  const iconWidth = height * 0.75;
  const totalWidth = iconOnly ? iconWidth : height * 4.5;

  if (iconOnly) {
    return (
      <svg
        width={iconWidth}
        height={height}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        {/* Two stacked horizontal arrows - no overlapping */}
        <g>
          {/* Top arrow pointing right */}
          <path
            d="M8 14 L32 14 L32 10 L40 18 L32 26 L32 22 L8 22 Z"
            fill={arrowColor}
            className="animate-arrow-right"
            style={{ transformOrigin: 'center' }}
          />
          {/* Bottom arrow pointing left */}
          <path
            d="M40 34 L16 34 L16 38 L8 30 L16 22 L16 26 L40 26 Z"
            fill={arrowColor}
            className="animate-arrow-left"
            style={{ transformOrigin: 'center' }}
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      width={totalWidth}
      height={height}
      viewBox="0 0 220 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Icon: Two stacked horizontal arrows - no overlapping */}
      <g>
        {/* Top arrow pointing right */}
        <path
          d="M8 14 L32 14 L32 10 L40 18 L32 26 L32 22 L8 22 Z"
          fill={arrowColor}
          className="animate-arrow-right"
          style={{ transformOrigin: 'center' }}
        />
        {/* Bottom arrow pointing left */}
        <path
          d="M40 34 L16 34 L16 38 L8 30 L16 22 L16 26 L40 26 Z"
          fill={arrowColor}
          className="animate-arrow-left"
          style={{ transformOrigin: 'center' }}
        />
      </g>

      {/* Wordmark: EMT Sync (30% larger) */}
      <text
        x="54"
        y="32"
        fontFamily="Inter, system-ui, -apple-system, sans-serif"
        fontSize="26"
        style={{ userSelect: 'none' }}
      >
        <tspan fontWeight="800" fill={emtTextColor}>EMT</tspan>
        <tspan fontWeight="600" fontStyle="italic" fill={syncTextColor} dx="4">Sync</tspan>
      </text>
    </svg>
  );
}